export default {"src":"/_next/static/media/Pool.27e00654.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};